// extracted by mini-css-extract-plugin
export default {"root":"terms-and-conditions_root__cM4ri"};